import { app } from '../../app.module'
// 投稿データ
export interface IPostData {
  publishDate: string
  accountId: string
  accountScreenName: string
  accountCategoryName: string
  accountSubCategoryName: string
  postDateFollowers: number | string
  type: string
  message?: string
  description?: string
  thumbnailUrl: string
  globalTagNames: string
  groupTagNames: string
  userTagNames: string
}

// アカウントデータ
export interface IAccountData {
  screenName: string
  brandName: string
  categoryName: string
  subCategoryName: string
  followers: string
  followersUpdownRate: number
  tags: {
    globalTagNames: string
    groupTagNames: string
    userTagNames: string
  }
  posts: number
}

/**
 * Csvダウンロード一般サービス
 */
export class CsvDownloadCommon {
  /**
   * タグリストを結合
   * @param {string} tagLists タグリスト
   * @param {string} tagName タグ名
   * @returns {string} タグリスト
   */
  public concatTag(tagLists: string, tagName: string): string {
    // タグ名がnullの場合、リターン
    if (tagName === null || tagName === undefined || tagName === '') {
      return tagLists
    }

    // タグリストがemptyの場合、タグ名としてリターン
    if (tagLists === '') {
      return tagName
    }

    return tagLists + ', ' + tagName
  }

  /**
   * パーセントを小数点2位まで表示するように変換する
   * ex. 11.05 % = 0.1105 のように出力する
   * @param {number} percentage パーセント
   * @return {string} 変換したパーセント
   */
  public convertPercentage(percentage: number): string {
    if (percentage !== null) {
      const fixedRate = percentage.toFixed(2)

      return fixedRate
    }
    return '0'
  }

  /**
   * 投稿タイプを変換する
   * @param {string} postType タイプ
   * @returns {string} 変換したタイプ
   */
  public convertPostType(postType: string): string {
    switch (postType) {
      case 'text':
        return 'テキスト'
      case 'link':
        return 'リンク'
      case 'photo':
        return '画像'
      case 'carousel':
        return 'カルーセル'
      case 'album':
        return 'アルバム'
      case 'video':
        return 'ビデオ'
      case '360-video':
        return '360°ビデオ'
      case 'live-video':
        return 'ライブビデオ'
      case 'animation-gif':
        return 'アニメーションGif'
      case 'offer':
        return 'クーポン'
      case 'note':
        return 'ノート'
      case 'rich_media':
        return 'キャンバス'
      default:
        return ''
    }
  }

  /**
   * 投稿本文が無い場合は別の文章を挿入
   * @param {string} message メッセージ
   * @returns {string} 変換したメッセージ
   */
  public convertPostMessage(message: string): string {
    if (message) {
      return message
    }
    return '投稿本文はありません。'
  }

  /**
   * アカウント詳細グラフの投稿数CSVをセット
   * @param dataPerObjectFlg 一投稿あたりフラグ
   * @param periodArray 期間リスト
   * @param data データ
   * @returns {string[][]} CSVデータ
   */
  public setAccountChangePostCount(dataPerObjectFlg: boolean, periodArray: {}[], data): string[][] {
    // CSVデータ
    const csvData = []

    if (dataPerObjectFlg === false) {
      csvData.push(['期間', '投稿数'])

      for (let key = 0; key < periodArray.length; key = key + 1) {
        csvData.push([periodArray[key], data.posts[key]])
      }
    } else {
      csvData.push(['期間', '投稿数(1アカウントあたり)'])

      for (let key = 0; key < periodArray.length; key = key + 1) {
        csvData.push([periodArray[key], data.postsPerAccount[key]])
      }
    }

    return csvData
  }

  /**
   * アカウント詳細グラフの反応率CSVをセット
   * @param periodArray 期間リスト
   * @param data データ
   * @returns {string[][]} CSVデータ
   */
  public setAccountChangeRespondRateCsv(periodArray: {}[], data): string[][] {
    // CSVデータ
    const csvData = []

    csvData.push(['期間', '反応率'])

    for (let key = 0; key < periodArray.length; key = key + 1) {
      csvData.push([periodArray[key], this.convertPercentage(data[key])])
    }

    return csvData
  }
}

// CSVダウンロード用のサービスを定義
app.service('CsvDownloadCommon', CsvDownloadCommon)
